import { Div } from '@pinpoint/design-kit';
import React from 'react';
import PropTypes from 'prop-types';
import { formatNumberV2, formatPercent } from 'src/functions';
import { YearDetailProp } from 'src/store/typings';
import adler32 from 'adler-32';

export default function YearImpactDetail({ year, ss, wP }) {
  return (
    <>
      <Div
        d="flex"
        align="center"
        justify="center"
        textWeight="700"
        gridArea={`2 / ${year * 6} / 3 / span 5`}
        bg="shadeEF"
        rounded="sm"
      >
        YEAR {year}
      </Div>
      <Div
        d="flex"
        align="center"
        justify="center"
        gridArea={`3 / ${year * 6} / 4 / span 1`}
        bg="skyBlue"
        rounded="sm"
        textColor="white"
        textAlign="center"
        textWeight="700"
      >
        Without
        <br />
        Pinpoint
      </Div>
      <Div
        d="flex"
        gridArea={`4 / ${year * 6} / 5 /  span 1`}
        bg="skyBluePale2"
        rounded="sm"
        textWeight="700"
        align="center"
        justify="right"
        textAlign="right"
        p={{ r: '.75rem' }}
      >
        Written
        <br />
        Policies
      </Div>
      {ss?.policies?.map?.((val, idx) => (
        <Div
          key={`cl-policies-${adler32.str(val.toString(), idx)}`}
          d="flex"
          align="center"
          justify="right"
          textAlign="right"
          p={{ x: '.75rem' }}
          gridArea={`${5 + idx} / ${year * 6} / ${6 + idx} / span 1`}
          bg="skyBluePale2"
          rounded="sm"
          whiteSpace="nowrap"
        >
          {formatNumberV2(val, true, true) ?? 0}
        </Div>
      ))}
      <Div
        data-test={`${year}-cl-policies-sum`}
        d="flex"
        align="center"
        justify="right"
        textAlign="right"
        p={{ x: '.75rem' }}
        gridArea={`15 / ${year * 6} / 16 / span 1`}
        bg="skyBluePale3"
        rounded="sm"
        whiteSpace="nowrap"
      >
        {formatNumberV2(ss.sumPolicies, true, true) ?? 0}
      </Div>
      <Div
        d="flex"
        p={{ r: '.75rem' }}
        align="center"
        justify="center"
        gridArea={`3 / ${year * 6 + 1} / 4 / span 4`}
        bg="tealLight"
        rounded="sm"
        textWeight="700"
        textColor="white"
        textAlign="center"
      >
        With Pinpoint
      </Div>
      <Div
        d="flex"
        gridArea={`4 / ${year * 6 + 1} / 5 / span 1`}
        bg="powderGreenPale2"
        rounded="sm"
        textWeight="700"
        align="center"
        justify="right"
        textAlign="right"
        p={{ r: '.75rem' }}
      >
        Written
        <br />
        Policies
      </Div>
      {wP.policies?.map?.((val, idx) => (
        <Div
          key={`ppt-policies-${adler32.str(val.toString(), idx)}`}
          d="flex"
          align="center"
          justify="right"
          textAlign="right"
          p={{ x: '.75rem' }}
          gridArea={`${5 + idx} / ${year * 6 + 1} / ${6 + idx} / span 1`}
          bg="powderGreenPale2"
          rounded="sm"
          whiteSpace="nowrap"
        >
          {formatNumberV2(val, true, true) ?? 0}
        </Div>
      ))}
      <Div
        data-test={`${year}-ppt-policies-sum`}
        d="flex"
        align="center"
        justify="right"
        textAlign="right"
        p={{ x: '.75rem' }}
        gridArea={`15 / ${year * 6 + 1} / 16 / span 1`}
        bg="greenDarkPale3"
        rounded="sm"
        whiteSpace="nowrap"
      >
        {formatNumberV2(wP.sumPolicies, true, true) ?? 0}
      </Div>
      <Div
        d="flex"
        gridArea={`4 / ${year * 6 + 2} / 5 / span 1`}
        bg="powderGreenPale2"
        rounded="sm"
        textWeight="700"
        align="center"
        justify="right"
        textAlign="right"
        p={{ r: '.75rem' }}
      >
        Written
        <br />
        Premium
      </Div>
      {wP.premium.map((val, idx) => (
        <Div
          key={`${year}-ppt-premium-${adler32.str(val, idx)}`}
          d="flex"
          align="center"
          justify="right"
          textAlign="right"
          p={{ x: '.75rem' }}
          gridArea={`${5 + idx} / ${year * 6 + 2} / ${6 + idx} / span 1`}
          bg="powderGreenPale2"
          rounded="sm"
          whiteSpace="nowrap"
        >
          ${formatNumberV2(val, true, true) ?? 0}
        </Div>
      ))}
      <Div
        data-test={`${year}-ppt-premium-sum`}
        d="flex"
        align="center"
        justify="right"
        textAlign="right"
        p={{ x: '.75rem' }}
        gridArea={`15 / ${year * 6 + 2} / 16 / span 1`}
        bg="greenDarkPale3"
        rounded="sm"
        whiteSpace="nowrap"
      >
        ${formatNumberV2(wP.sumPremium, true, true) ?? 0}
      </Div>
      <Div
        d="flex"
        align="center"
        justify="right"
        textAlign="right"
        p={{ r: '.75rem' }}
        gridArea={`4 / ${year * 6 + 3} / 5 / span 1`}
        bg="powderGreenPale2"
        rounded="sm"
        textWeight="700"
      >
        Loss
      </Div>
      {wP.loss.map((val, idx) => (
        <Div
          key={`ppt-loss-${adler32.str(val, idx)}`}
          d="flex"
          align="center"
          justify="right"
          textAlign="right"
          p={{ x: '.75rem' }}
          gridArea={`${5 + idx} / ${year * 6 + 3} / ${6 + idx} / span 1`}
          bg="powderGreenPale2"
          rounded="sm"
          whiteSpace="nowrap"
        >
          ${formatNumberV2(val, true, true) ?? 0}
        </Div>
      ))}
      <Div
        data-test={`${year}-ppt-loss-sum`}
        d="flex"
        align="center"
        justify="right"
        textAlign="right"
        p={{ x: '.75rem' }}
        gridArea={`15 / ${year * 6 + 3} / 16 / span 1`}
        bg="greenDarkPale3"
        rounded="sm"
        whiteSpace="nowrap"
      >
        ${formatNumberV2(wP.sumLoss, true, true) ?? 0}
      </Div>
      <Div
        d="flex"
        align="center"
        justify="right"
        textAlign="right"
        p={{ r: '.75rem' }}
        gridArea={`4 / ${year * 6 + 4} / 5 / span 1`}
        bg="powderGreenPale2"
        rounded="sm"
        textWeight="700"
      >
        Loss
        <br />
        Ratio
      </Div>
      {wP.lr.map((val, idx) => (
        <Div
          key={`ppt-lr-${val}`}
          d="flex"
          align="center"
          justify="right"
          textAlign="right"
          p={{ x: '.75rem' }}
          gridArea={`${5 + idx} / ${year * 6 + 4} / ${6 + idx} / span 1`}
          bg="powderGreenPale2"
          rounded="sm"
          whiteSpace="nowrap"
        >
          {formatPercent(ss.sumPolicies ? val * 100 : 0, false)}
        </Div>
      ))}
      <Div
        data-test={`${year}-ppt-lr-sum`}
        d="flex"
        align="center"
        justify="right"
        textAlign="right"
        p={{ x: '.75rem' }}
        gridArea={`15 / ${year * 6 + 4} / 16 / span 1`}
        bg="greenDarkPale3"
        rounded="sm"
        whiteSpace="nowrap"
      >
        {formatPercent(ss.sumPolicies ? wP.totalLR * 100 : 0, false)}
      </Div>
    </>
  );
}

YearImpactDetail.propTypes = {
  year: PropTypes.number.isRequired,
  ss: YearDetailProp.isRequired,
  wP: YearDetailProp.isRequired,
};
